import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'app-launch-store-button',
  styleUrl: 'app-store-button.css',
  shadow: true,
})
export class AppStoreButton {
  @Prop() href: string;
  @Prop() imageSrc: string;

  render() {
    return (
      <a id="app-link" href={this.href} target="_blank" rel="noreferrer noopener">
        <img src={this.imageSrc} />
      </a>
    );
  }
}
